'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useState, useEffect, cloneElement } from 'react';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { useBinding } from '../../hooks/useBinding/useBinding.js';
import { Card } from '../Card/Card.js';
import { CardHeader } from '../CardHeader/CardHeader.js';
import { IconButton } from '../IconButton/IconButton.js';
import '../Icons/AlignStartHorizontalIcon.js';
import '../Icons/ArchiveIcon.js';
import '../Icons/ArrowDownIcon.js';
import '../Icons/ArrowLeftBottomIcon.js';
import '../Icons/ArrowLeftIcon.js';
import '../Icons/ArrowLeftTopIcon.js';
import '../Icons/ArrowRightBottomIcon.js';
import '../Icons/ArrowRightIcon.js';
import '../Icons/ArrowRightTopIcon.js';
import '../Icons/BagIcon.js';
import '../Icons/BasketIcon.js';
import '../Icons/BellFilledIcon.js';
import '../Icons/BellNotificationIcon.js';
import '../Icons/BellOutlineIcon.js';
import '../Icons/BinocularsIcon.js';
import '../Icons/BlocksIcon.js';
import '../Icons/BoltIcon.js';
import '../Icons/BookIcon.js';
import '../Icons/BookmarkAddFilledIcon.js';
import '../Icons/BookmarkAddOutlineIcon.js';
import '../Icons/BookmarkIcon.js';
import '../Icons/BookOpenedIcon.js';
import '../Icons/BoxAltIcon.js';
import '../Icons/BusinessIcon.js';
import '../Icons/CalendarIcon.js';
import '../Icons/CancelIcon.js';
import '../Icons/CardsIcon.js';
import '../Icons/ChatAltIcon.js';
import '../Icons/ChatIcon.js';
import '../Icons/CheckboxIcon.js';
import '../Icons/CheckCirlcleFilledIcon.js';
import '../Icons/CheckSquareIcon.js';
import '../Icons/ChevronDoubleLeftIcon.js';
import '../Icons/ChevronDoubleRightIcon.js';
import '../Icons/ChevronDownIcon.js';
import '../Icons/ChevronLeftIcon.js';
import '../Icons/ChevronRightIcon.js';
import '../Icons/ChevronUpIcon.js';
import '../Icons/ClipboardEditIcon.js';
import '../Icons/ClipboardIcon.js';
import { CloseIcon } from '../Icons/CloseIcon.js';
import '../Icons/CollapseIcon.js';
import '../Icons/ControlsIcon.js';
import '../Icons/ControlsVerticalAltIcon.js';
import '../Icons/CopyIcon.js';
import '../Icons/CutIcon.js';
import '../Icons/DangerIcon.js';
import '../Icons/DownloadCloudIcon.js';
import '../Icons/DownloadIcon.js';
import '../Icons/DownloadPdfIcon.js';
import '../Icons/DrawerOpenIcon.js';
import '../Icons/EllipsisIcon.js';
import '../Icons/EllypsisVerticalIcon.js';
import '../Icons/EnvelopeIcon.js';
import '../Icons/ErrorIcon.js';
import '../Icons/ExitIcon.js';
import '../Icons/ExpandIcon.js';
import '../Icons/ExternalLinkIcon.js';
import '../Icons/EyeCrossedIcon.js';
import '../Icons/EyeIcon.js';
import '../Icons/FacebookIcon.js';
import '../Icons/FavouriteIcon.js';
import '../Icons/FileBadgeIcon.js';
import '../Icons/FileIcon.js';
import '../Icons/FileSearchIcon.js';
import '../Icons/FileType2Icon.js';
import '../Icons/FilmIcon.js';
import '../Icons/FitscreenIcon.js';
import '../Icons/FocusIcon.js';
import '../Icons/FolderAddIcon.js';
import '../Icons/FolderClosedIcon.js';
import '../Icons/FolderIcon.js';
import '../Icons/FutureIcon.js';
import '../Icons/GalleryVerticalEndIcon.js';
import '../Icons/GridIcon.js';
import '../Icons/HelpIcon.js';
import '../Icons/HistoryIcon.js';
import '../Icons/HomeIcon.js';
import '../Icons/InformationIcon.js';
import '../Icons/InstagramIcon.js';
import '../Icons/LibraryIcon.js';
import '../Icons/LightbulbIcon.js';
import '../Icons/LinkedinIcon.js';
import '../Icons/ListIcon.js';
import '../Icons/ListSearchIcon.js';
import '../Icons/Loader2Icon.js';
import '../Icons/LockAltIcon.js';
import '../Icons/LockAltOpenIcon.js';
import '../Icons/LockIcon.js';
import '../Icons/LockOpenIcon.js';
import '../Icons/MagazineIcon.js';
import '../Icons/MailIcon.js';
import '../Icons/Maximize2Icon.js';
import '../Icons/MenuCollapsable2Icon.js';
import '../Icons/MenuCollapsableIcon.js';
import '../Icons/MenuDotsIcon.js';
import '../Icons/MenuIcon.js';
import '../Icons/MinusIcon.js';
import '../Icons/NewsIcon.js';
import '../Icons/NtfrIcon.js';
import '../Icons/OkCircleIcon.js';
import '../Icons/OkIcon.js';
import '../Icons/PencilIcon.js';
import '../Icons/PenSquareIcon.js';
import '../Icons/People2Icon.js';
import '../Icons/PeopleIcon.js';
import '../Icons/PersonIcon.js';
import '../Icons/PhoneCallIcon.js';
import '../Icons/PlayFilledIcon.js';
import '../Icons/PlayIcon.js';
import '../Icons/PlusCircleIcon.js';
import '../Icons/PlusIcon.js';
import '../Icons/PlusSquareIcon.js';
import '../Icons/PrintIcon.js';
import '../Icons/RadioIcon.js';
import '../Icons/RefreshCwIcon.js';
import '../Icons/RotateIcon.js';
import '../Icons/SearchIcon.js';
import '../Icons/SettingsIcon.js';
import '../Icons/ShareIcon.js';
import '../Icons/ShieldIcon.js';
import '../Icons/SocialXIcon.js';
import '../Icons/StarFilledIcon.js';
import '../Icons/StarOutlineIcon.js';
import '../Icons/StickyNoteIcon.js';
import '../Icons/SwapHorizontalIcon.js';
import '../Icons/TablePropertiesIcon.js';
import '../Icons/TasklistIcon.js';
import '../Icons/ThumbDownIcon.js';
import '../Icons/ThumbsDownIcon.js';
import '../Icons/ThumbsUpIcon.js';
import '../Icons/ThumbUpIcon.js';
import '../Icons/TimeIcon.js';
import '../Icons/TimerIcon.js';
import '../Icons/Trash2Icon.js';
import '../Icons/TrashIcon.js';
import '../Icons/UpgradeIcon.js';
import '../Icons/UploadIcon.js';
import '../Icons/UserIcon.js';
import '../Icons/VideoIcon.js';
import '../Icons/WorldIcon.js';
import '../Icons/XposiIcon.js';
import '../Icons/YoutubeIcon.js';

const CardHeaderLinkBlock = ({
  isExpanded,
  collapseComponent,
  expandComponent,
  labelExpand,
  labelCollapse,
  onClick
}) => {
  const collapseEl = useRef(null);
  const expandEl = useRef(null);
  const [hasFocus, setHasFocus] = useState(false);
  useEffect(() => {
    if (!hasFocus) return;
    if (isExpanded && collapseEl.current) {
      collapseEl.current.focus();
    }
    if (!isExpanded && expandEl.current) {
      expandEl.current.focus();
    }
  }, [isExpanded, hasFocus]);
  const closeButton = collapseComponent ? cloneElement(collapseComponent, {
    onClick,
    'aria-expanded': true,
    'aria-label': labelCollapse,
    ref: collapseEl,
    onFocus: () => setHasFocus(true),
    onBlur: () => setHasFocus(false)
  }) : jsx(IconButton, {
    ref: collapseEl,
    "aria-expanded": true,
    "aria-label": labelCollapse,
    hasBackground: false,
    hasBackgroundOnHover: false,
    icon: jsx(CloseIcon, {}),
    padding: 2,
    size: 16,
    testId: "cardHeaderLinkBClose",
    variant: "secondary",
    onBlur: () => {
      setHasFocus(false);
    },
    onClick: onClick,
    onFocus: () => {
      setHasFocus(true);
    }
  });
  if (isExpanded) {
    return closeButton;
  }
  return cloneElement(expandComponent, {
    onClick,
    'aria-expanded': false,
    'aria-label': labelExpand,
    ref: expandEl,
    onFocus: () => setHasFocus(true),
    onBlur: () => setHasFocus(false)
  });
};
const CardCollapsible = /*#__PURE__*/withTitan(_a => {
  var {
      noPadding,
      expandComponent,
      children,
      collapseComponent,
      description,
      footer,
      isExpanded,
      isDefaultExpanded = true,
      onChangeExpanded,
      labelExpand = 'Kaart openklappen',
      labelCollapse = 'Kaart dichtklappen',
      testId = 'cardCollapsible',
      title
    } = _a,
    rest = __rest(_a, ["noPadding", "expandComponent", "children", "collapseComponent", "description", "footer", "isExpanded", "isDefaultExpanded", "onChangeExpanded", "labelExpand", "labelCollapse", "testId", "title"]);
  const [isExpandedBinding, setExpanded] = useBinding(isDefaultExpanded, isExpanded, onChangeExpanded, false);
  const toggleExpanded = () => setExpanded(!isExpandedBinding);
  return jsxs(Card, Object.assign({}, rest, isExpandedBinding ? {
    footer
  } : {
    showDivider: false
  }, {
    testId: testId,
    children: [jsx(CardHeader, {
      actions: jsx(CardHeaderLinkBlock, {
        collapseComponent: collapseComponent,
        "data-test-id": `${testId}Expander`,
        expandComponent: expandComponent,
        isExpanded: isExpandedBinding,
        labelCollapse: labelCollapse,
        labelExpand: labelExpand,
        onClick: toggleExpanded
      }),
      description: description,
      hasDivider: isExpandedBinding,
      title: title
    }), !!isExpandedBinding && children]
  }));
}, {
  name: 'CardCollapsible'
});

export { CardCollapsible };
//# sourceMappingURL=CardCollapsible.js.map
